export default __webpack_public_path__ + "static/media/1.1f95e6a4.png";